import { format } from 'date-fns';
import { TUI_DATE_VALUE_TRANSFORMER } from '@taiga-ui/kit';
import { AbstractTuiValueTransformer, TuiDay } from '@taiga-ui/cdk';
import { Directive, Injectable } from '@angular/core';

type From = TuiDay | null;
type To = Date | string | null;

@Injectable()
class ExampleTransformer extends AbstractTuiValueTransformer<From, To> {
  public fromControlValue(controlValue: To): From {
    return controlValue ? TuiDay.fromLocalNativeDate(new Date(controlValue)) : null;
  }

  public toControlValue(componentValue: From): To {
    return componentValue ? format(componentValue.toLocalNativeDate(), 'yyyy-MM-dd') : null;
  }
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'tui-input-date[woNativeDate]',
  providers: [
    {
      provide: TUI_DATE_VALUE_TRANSFORMER,
      useClass: ExampleTransformer,
    },
  ],
  standalone: true,
})
export class NativeDayDirective {}
